module.exports = __webpack_public_path__ + "img/crusher.c1a0e95e.png";